<template>
  <v-container
    class="main-container"
    @dragover="dragover"
    @dragleave="dragleave"
    @drop="drop"
  >
  <p class="text-h6 font-weight-light text-uppercase">{{ $t('uploadIndividualVatRecord') }}</p>
  <v-row justify="center" align="center">
  <v-col xs="12" sm="12" md="6" lg="6">
    </v-col>
    <v-col xs="8" sm="8" md="4" lg="4" align="right">
    <p>
        <a @click="downloadTemplate()">
            {{ $t('downloadIndividualVatRecordTemplate') }}
        </a>
    </p>
    </v-col>
  </v-row>
    <v-row justify="center" align="center">
      <v-col cols="8">
        <v-card color="grey lighten-3 pa-5">            
          <v-card-title class="justify-center">{{ $t('uploadExcelFile') }}</v-card-title>

          <v-file-input
            v-bind:label="$t('excelFile')"
            @change="onChange"
            @click:clear="clearFileInput()"
            ref="fileInput"
            accept=".xlsx"
            outlined
            dense
          ></v-file-input>

          <v-row v-if="currentFile != undefined && showChoosedFile">
            <v-col cols="9">
              {{ $t('selectedFile') }}: {{ currentFile.name }}
            </v-col>
          </v-row>

          <v-card-actions class="justify-center mt-5">
            <v-btn @click="uploadFile()">{{ $t('uploadFile') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!--  No file chosen dialog  -->
    <v-dialog v-model="showNoChosenFileDialog" persistent width="40%">
      <v-card>
        <v-card-title class="headline">
          {{ $t('notification') }}!
        </v-card-title>
        <v-card-text>{{ message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="showNoChosenFileDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
    import { v4 as uuidv4 } from 'uuid'

    export default {
        name: "UploadXml",
        data() {
            return{
                message: "",
                currentFile: "",
                showNoChosenFileDialog: false,
                showChoosedFile: false,
            }
        },
        methods: {
            clearFileInput() {
                this.currentFile = "";
                this.showChoosedFile = false;
            },
            onChange(e) {
                let file = e;
                this.currentFile = file;
                this.showChoosedFile = true;
            },
            uploadFile() {
                if (
                    this.currentFile == "" ||
                    this.currentFile == null ||
                    this.currentFile == undefined
                ) {
                    this.message = this.$t('xlsxFileRequired');
                    this.showNoChosenFileDialog = true;
                    return;
                }
                var formData = new FormData();
                formData.append('file', this.currentFile);
                this.axios.post('VatRecord/UploadExcel?organizationId=' + this.$store.getters.organizationId, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }).then(response => {
                    if(response && response.status === 200) {
                        this.message = this.$t('allVatRecordSent');
                        this.showNoChosenFileDialog = true;
                        this.clearFileInput();
                    }
                })
                .catch((error) => { 
                    console.log("Error: " + error);
                    console.log(error.response.data); 
                    this.message = error.response.data;
                    this.showNoChosenFileDialog = true; 
                })
            },
            downloadTemplate() {
                this.axios({
                    url: 'VatRecord/DownloadIndividualVatRecordTemplate',
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {  
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    var contetnType = response.headers['content-type'];
            
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download',  this.$t('individualVatRecordTemplate')); 
                    
                    document.body.appendChild(fileLink);     
                    fileLink.click();
                    //this.filterInvoices();          
                    })
                    .catch(err => console.log(err));  
            },
            dragover(event) {
                event.preventDefault();
                // Add some visual effects to show the user can drop its files
                if (!event.currentTarget.classList.contains("bg-green-300")) {
                    event.currentTarget.classList.remove("bg-gray-100");
                    event.currentTarget.classList.add("bg-green-300");
                }
            },
            dragleave(event) {
                // Clean up
                event.currentTarget.classList.add("bg-gray-100");
                event.currentTarget.classList.remove("bg-green-300");
            },
            drop(event) {
                event.preventDefault();

                this.onChange(event.dataTransfer.files[0]);
                // Clean up
                event.currentTarget.classList.add("bg-gray-100");
                event.currentTarget.classList.remove("bg-green-300");
            },
        }
    }
</script>

